import {Button, Input, InputNumber, Modal, Progress, Select} from "antd";

const { TextArea } = Input;
const Option = Select.Option;
export default function AddEpisode( {props} ) {

  return <>
    <Modal
        visible={props.visible}
        title="Add New Episode"
        onOk={props.createEpisode}
        onCancel={props.toggleAddEpisode}
        footer={[
          <Button key="back"
                  onClick={props.toggleAddEpisode}>
            Return
          </Button>,
          <Button type="primary"
                  key="submit"
                  className={'btn btn-success'}
                  loading={props.loading}
                  onClick={props.createEpisode}>
            Submit
          </Button>
        ]}>
      <div className="p-2">
        <span>Course</span>
        <Select
            value={props.course}
            onChange={(e) => {
              props.setNewCourse(e)
            }}
            showSearch
            size="default"
            placeholder={'Select Course'}
            filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            className="w-100percent ant-input mw-150">
          {props.courses?.map((mode, index) => (
              <Option value={mode.id} key={index}>
                {mode.course_name}
              </Option>
          ))}
        </Select>
      </div>
      <div className="p-2">
        <span>Episode Number</span>
        <InputNumber placeholder="Input Episode Number"
                     className="w-100percent"
                     min={1}
                     max={1000}
                     value={props.episodeNumber}
                     onChange={(e) => props.setEPNumber(e)} />
      </div>

      <div className="p-2">
        <span>Episode Name</span>
        <Input placeholder="Input Episode Name"
               value={props.episodeName}
               onChange={(e) => props.setEPName(e.target.value)}/>
      </div>

      <div className="p-2">
        <span>Description</span>
        <TextArea placeholder="Add Description Here"
                  autosize={{ minRows: 5, maxRows: 6 }}
                  value={props.description}
                  onChange={(e) => props.setDesc(e.target.value)}/>
      </div>

      <div className="p-2">
        <span>Link</span>
        <Input placeholder="Add description here"
               value={props.link}
               onChange={(e) => props.setLink(e.target.value)}/>
      </div>

      <div className="py-3 px-2 d-flex flex-col">
        <label className={'w-100percent'}>
          Upload Thumbnail
        </label>
        <div className={'w-100percent pt-1'}>
          <button onClick={props.thumbnailClick}>
            Choose File
          </button>
          <span className='ml-2'>{props.thumbnail?.name || 'No file chosen'}</span>
          <input type="file"
                 id='thumbnail'
                 name='filename'
                 value=''
                 hidden
                 accept="image/png, image/gif, image/jpeg"
                 onChange={(e) => {
                   props.setThumbnail(e.target.files[0]);
                 }}/>
        </div>
      </div>
    </Modal>
  </>
}
